const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': 'Prometno dovoljenje vozila',
	'vehicleRegistrationDocument.description':
		'Naložite jasne fotografije zahtevanih strani prometnega dovoljenja.',
	'vehicleRegistrationDocument.RegistrationDocument.title': 'Sprednja stran prometnega dovoljenja',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'Posnemite jasno fotografijo sprednje strani prometnega dovoljenja.',
	'vehicleRegistrationDocument.RegistrationDocument.headline':
		'Sprednja stran prometnega dovoljenja',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle':
		'Sprednja stran prometnega dovoljenja - primer',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired':
		'Sprednja stran prometnega dovoljenja',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title':
		'Zadnja stran prometnega dovoljenja',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'Posnemite jasno fotografijo zadnje strani prometnega dovoljenja.',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline':
		'Zadnja stran prometnega dovoljenja',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'Zadnja stran prometnega dovoljenja - primer',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired':
		'Zadnja stran prometnega dovoljenja',
	'vehicleRegistrationDocument.validationHeadline': 'Manjkajoče fotografije',
	'vehicleRegistrationDocument.validationDescription': 'Dodajte naslednje fotografije:',
	'landing.stepDescription.vehicleRegistrationDocument': 'Fotografirajte prometno dovoljenje',
	'review.stepDescription.vehicleRegistrationDocument': 'Prometno dovoljenje vozila',
	'loader.loading': 'Nalaganje podatkov ...',
	'loader.error': 'Vašega postopka ni bilo mogoče naložiti. Znova poskusite pozneje.',
	'connectionError.title': 'Napaka v povezavi',
	'connectionError.description': 'Napaka v povezavi. Znova naložite fotografije.',
	'mainError.tryAgain': 'Poskusite znova.',
	'landing.headline.policyCheck': 'Dober dan!',
	'landing.paragraph': 'Samo še dva koraka te ločita od dokončanja digitalnega pregleda vozila.',
	'landing.stepDescription.fourAdditionalPictures': 'Posnemi zahtevane fotografije',
	'landing.stepDescription.feedback': 'Sporoči nam, kako je šlo',
	'landing.termsAndConditionsLinkDescription':
		'S klikom na »Pojdi« sprejemaš <tclink>naše pogoje</tclink>',
	'landing.termsAndConditionsLink': 'S klikom na »Pojdi« sprejemaš naše pogoje',
	'button.start': 'Pojdi',
	'button.close': 'V redu',
	'landing.aboutPolicyCheck': 'Vrni se',
	'tutorialModal.headline.first.policyCheck': 'Kaj pomeni Digitalni pregled vozila?',
	'tutorialModal.paragraph.first.policyCheck':
		'Digitalni pregled vozila je hitro preverjanje stanja vozila na podlagi dostavljenih fotografij. Postopek je sestavljen iz osmih preprostih korakov.',
	'chooseLang.headline': 'Izberite želeni jezik',
	'blockedByDevice.headline': 'Digitalni pregled vozila ne podpira namiznih brskalnikov.',
	'blockedByDevice.description':
		'Digitalni pregled vozila uporablja namizni brskalnik.<br>Do aplikacije za digitalni pregled vozila lahko dostopate prek mobilnih naprav. Če želite nadaljevati, zaženite aplikacijo na svoji mobilni napravi.',

	'vehicleImages.overviewPhotos': 'Pregled vozila',
	'vehicleImages.description':
		'Vozilo fotografiraj z vseh strani. Registrska oznaka mora biti jasno vidna na vseh fotografijah.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Sprednja leva diagonala',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Zadnja leva diagonala',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Zadnja desna diagonala',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Sprednja desna diagonala',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Primer fotografije',
	'button.next': 'Naprej',

	'imageRecognitionMismatchModal.headline': 'Preveri, ali so fotografije pravilno naložene',
	'button.continue': 'Nadaljuj',
	'button.backchangeImage': 'Fotografiraj ponovno',

	'vehicleImages.leftFrontOverview': 'Sprednja leva diagonala',
	'vehicleImages.leftRearOverview': 'Zadnja leva diagonala',
	'vehicleImages.rightRearOverview': 'Zadnja desna diagonala',
	'vehicleImages.rightFrontOverview': 'Sprednja desna diagonala',
	'button.changeImage': 'Fotografiraj ponovno',

	'completeVehicleImagesModal.headline': 'Manjkajoče fotografije',
	'completeVehicleImagesModal.description': 'Prosimo, dodaj naslednje fotografije:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Sprednja leva diagonala',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Zadnja leva diagonala',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Zadnja desna diagonala',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Sprednja desna diagonala',
	'button.ok': 'V redu',

	'fourPerspectivesExampleModal.headline.first': 'Primer fotografije sprednje leve diagonale',
	'fourPerspectivesExampleModal.headline.second': 'Primer fotografije zadnje leve diagonale',
	'fourPerspectivesExampleModal.headline.third': 'Primer fotografije zadnje desne diagonale',
	'fourPerspectivesExampleModal.headline.fourth': 'Primer fotografije sprednje desne diagonale',
	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Primer fotografije sprednje leve diagonale',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'Primer fotografije zadnje leve diagonale',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Primer fotografije zadnje desne diagonale',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Primer fotografije sprednje desne diagonale',
	'fourPerspectivesExampleModal.button.close': 'V redu',

	'button.prev': 'Vrni se',
	'fourAdditionalPictures.title': 'Dodatne informacije',
	'fourAdditionalPictures.overallDashboard.title': 'Armaturna plošča',
	'fourAdditionalPictures.overallDashboard.description':
		'Fotografiraj tako, da je vidna celotna nadzorna plošča vozila',
	'fourAdditionalPictures.mileage.title': 'Št. prevoženih kilometrov',
	'dashboardMileage.dashboard.paragraph':
		'Fotografiraj število prevoženih kilometrov. Če ima tvoje vozilo digitalni prikazovalnik, ga vklopi.',
	'dashboardMileage.paragraph.first': 'Vpiši število prevoženih kilometrov vozila',
	'dashboardMileage.placeholder': 'Trenutna kilometrina',
	'dashboardMileage.input.error': 'Prosimo, vnesite trenutno kilometrino vozila.',
	'fourAdditionalPictures.windshield.title': 'Vetrobransko steklo',
	'fourAdditionalPictures.windshield.description':
		'Posnemi podrobno fotografijo vetrobranskega stekla svojega vozila.',
	'fourAdditionalPictures.vin.title': 'Številka šasije',
	'fourAdditionalPictures.vin.description':
		'Fotografiraj številko šasije svojega vozila. To lahko najdeš na voznikovem vratnem tesnilu ali v spodnjem levem kotu vetrobranskega stekla.',

	'imageRecognitionMistmatchModal.headline': 'Preveri, ali so fotografije pravilno naložene',
	'completeFourAdditionalPicturesModal.headline': 'Manjkajoče fotografije',
	'completeFourAdditionalPicturesModal.description': 'Prosimo, naloži naslednje fotografije:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Armaturna plošča',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Št. prevoženih kilometrov',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Vetrobransko steklo',
	'completeFourAdditionalPicturesModal.hasVINImage': 'Številka šasije',
	'completeDashboardMileageModal.hasValidMileage': 'Prosimo, vnesite trenutno kilometrino vozila.',

	'mismatchModal.enteredMileage': 'Vneseno število prevoženih kilometrov',

	'overallDashboardImage.headline': 'Armaturna plošča',
	'dashboardMileage.dashboard.title': 'Št. prevoženih kilometrov',
	'windshieldImage.headline': 'Vetrobransko steklo',
	'vinPicture.headline': 'Številka šasije',

	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Primer fotografije nadzorne plošče',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Primer fotografije s kilometrino',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Primer fotografije vetrobranskega stekla',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Primer fotografije šasije',
	'fourAdditionalPicturesExampleModal.headline.first': 'Primer fotografije nadzorne plošče',
	'fourAdditionalPicturesExampleModal.headline.second': 'Primer fotografije s kilometrino',
	'fourAdditionalPicturesExampleModal.headline.third': 'Primer fotografije vetrobranskega stekla',
	'fourAdditionalPicturesExampleModal.headline.fourth': 'Primer fotografije šasije',
	'fourAdditionalPicturesExampleModal.button.close': 'V redu',
	'upload.message': 'Tvoji podatki se nalagajo. Ta postopek lahko traja nekaj minut.',

	'review.button.next': 'Naprej',

	'feedback.headline.policyCheck': 'Fotografije so bile uspešno prejete!',
	'feedback.rating.policyCheck': 'Prosimo, oceni aplikacijo',
	'feedback.yourOpinion': 'Imaš dodatne pripombe? Sporoči nam!',
	'feedback.comment.placeholder': 'Dodaj pripombo',
	'feedback.button.send': 'Pošlji',
	'thanks.headline.first': 'Hvala za povratne informacije!',
	'waitForAudit.thankYou': 'Hvala za povratne informacije!',
	'thanks.paragraph.first': ' ',
	'waitForAudit.description.damageFound': ' ',

	//translations out of allianz si
	'landing.stepDescription.fourDiagonalPerspectives': 'Posnemi zahtevane fotografije.',
	'button.accept': 'Sprejmi',
	'landing.stepDescription.vehicleInformation': 'Podrobnosti vozila',
	'landing.additional-informations-section.title':
		'Pred začetkom fotografiranja vozila preverite, da:',
	'landing.additional-informations-section.text':
		'<ul>' +
		'<li>imate pri roki ključe vozila in prometno dovoljenje;</li>' +
		'<li>je na mestu, kjer ste, zagotovljena dobra osvetlitev in močen signal mobilnega omrežja;</li>' +
		'<li>je vozilo dostopno z vseh strani in da so zaprta vsa stranska stekla. </li>' +
		'</ul>',
	'vehicleImages.overviewPhotos.subtitle': 'Fotografirajte vozilo',
	'editPhoto.edit': 'Sprememba',
	'vehicleImages.details.first': 'Sprednji del vozila',
	'vehicleImages.details.second': 'Desna stran vozila',
	'vehicleImages.details.third': 'Zadnja stran vozila',
	'vehicleImages.details.fourth': 'Leva stran vozila',
	'completeVehicleImagesModal.hasVehicleImageFront': 'Sprednji del vozila',
	'completeVehicleImagesModal.hasVehicleImageRight': 'Desna stran vozila',
	'completeVehicleImagesModal.hasVehicleImageRear': 'Zadnja stran vozila',
	'completeVehicleImagesModal.hasVehicleImageLeft': 'Leva stran vozila',
	'button.deleteImage': 'Izbriši fotografijo',

	'timeout.bottom': ' ',
	'timeout.headline.first': 'Povezava do aplikacije ni več aktivna',
	'button.reverse': 'Ohrani fotografijo kilometrine',
	'button.confirm': 'Potrdi mojo kilometrino',
	'mileageModal.headline': 'Preverimo, ali je vneseno število prevoženih kilometrov pravilno',
	'mileageModal.paragraph':
		'Število prevoženih kilometrov na fotografiji se razlikuje od vnesenega v polje. Spremeni število ali ga potrdi za nadaljevanje, če je pravilno vneseno.',
	'mileageModal.insertedMileagePlaceholder': 'Vneseno število prevoženih kilometrov',
	'mileageModal.pictureMileage': 'Število prevoženih kilometrov povzeto po fotografiji',

	'invalidFile.size.title': 'Nepravilna velikost fotografije',
	'invalidFile.size.description': 'Velikost slike je večja od največje zahtevane velikosti',
	'invalidFile.extension.title': 'Vrsta datoteke ni podprta',
	'invalidFile.extension.description':
		'Izbrana vrsta datoteke ni podprta. Podprte vrste datotek: .jpg, .jpeg, .jfif, .heic, .heif, .png in .bmp',
	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',
	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',
};

export default messages;
